module.exports = __webpack_public_path__ + "img/10.aa1c0475.png";